import cx from "classnames";
import { useNavigation } from "react-router";

interface SubmitBtnProps {
  formBtn?: boolean;
}

const SubmitBtn = ({ formBtn = false }: SubmitBtnProps) => {
  const navigation = useNavigation();
  const isSubmitting = navigation.state === "submitting";

  return (
    <button type="submit" className={cx("btn btn-block", { "form-btn": formBtn })} disabled={isSubmitting}>
      {isSubmitting ? "submitting..." : "submit"}
    </button>
  );
};

export default SubmitBtn;
